import * as Yup from 'yup';
import createCargoFormModel from './createCargoFormModel';

const {
  formField: {
    name,
    description,
    area
  }

} = createCargoFormModel;


export default [

  Yup.object().shape({ 
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),    
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
    [area.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${area.requiredErrorMsg}`),
  })
  
];  

    